import type { StandardSvgProps } from "src/components/svg/StandardSvgProps";
import classNames from "classnames";
import svgStyles from "./SVGStyles.module.css";


export default function CheckmarkSvg({ className }: StandardSvgProps) {
	return (<svg className={classNames(svgStyles.SDefaultSvg, className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.678 17.678">
		<path d="m 10.726798,13.693334 -0.02758,0.02758 a 1.5,1.5 0 0 1 -2.09374,-0.02758 L 0.82730336,5.9151596 a 1.5,1.5 0 0 1 0,-2.1213204 1.5,1.5 0 0 1 2.12132034,0 L 9.6661381,10.511354 14.262332,5.9151596 a 1.5,1.5 0 0 1 2.121321,0 1.5,1.5 0 0 1 0,2.1213203 z" />
	</svg>);
}
